import { EntranceTicketTypeColumn, EntranceConfigurationEditMutation } from '../types';

const statusOnChange = async (
  item: EntranceTicketTypeColumn | undefined,
  editMutation: EntranceConfigurationEditMutation,
  refetch: () => Promise<unknown>
): Promise<unknown> => {
  const id = item?.actions.id || '';
  const toEdit = { id, status: !item?.status };
  const edited = await editMutation({
    variables: { input: toEdit },
  });
  await refetch();
  return edited;
};

export default statusOnChange;
